'use client'

import React, { Fragment } from 'react'
import dynamic from 'next/dynamic'

import { RichTextBlockComponent } from './RichTextBlockComponent'
import { ImageBlockComponent } from './ImageBlockComponent'
import { DocumentsBlockComponent } from './DocumentsBlockComponent'
import { SectionBlockComponent } from './SectionBlockComponent'
import { CallToActionBlockComponent } from './CallToActionBlockComponent'
import { ImageTextBlockComponent } from './ImageTextBlockComponent'

const VideoBlockComponent = dynamic(
  () => import('./VideoBlockComponent').then((m) => m.VideoBlockComponent),
  { ssr: false },
)
const VideoRowBlockComponent = dynamic(
  () => import('./VideoRowBlockComponent').then((m) => m.VideoRowBlockComponent),
  { ssr: false },
)

type ContentBlock =
  | ({ blockType: 'courseRichText' } & Record<string, any>)
  | ({ blockType: 'courseImage' } & Record<string, any>)
  | ({ blockType: 'courseVideo' } & Record<string, any>)
  | ({ blockType: 'courseVideoRow' } & Record<string, any>)
  | ({ blockType: 'courseDocuments' } & Record<string, any>)
  | ({ blockType: 'pageRichText' } & Record<string, any>)
  | ({ blockType: 'pageSection' } & Record<string, any>)
  | ({ blockType: 'pageCallToAction' } & Record<string, any>)
  | ({ blockType: 'pageImageText' } & Record<string, any>)

type Props = {
  blocks: ContentBlock[]
  className?: string
}

export const RenderContentBlocks: React.FC<Props> = ({ blocks, className }) => {
  if (!blocks || !blocks.length) return null

  return (
    <div className={className}>
      {blocks.map((block, index) => {
        const { blockType } = block
        const key = block.id ?? `block-${index}`

        switch (blockType) {
          case 'courseRichText':
          case 'pageRichText':
            return <RichTextBlockComponent key={key} {...block} />
          case 'courseImage':
            return <ImageBlockComponent key={key} {...block} />
          case 'courseVideo':
            return <VideoBlockComponent key={key} {...block} />
          case 'courseVideoRow':
            return <VideoRowBlockComponent key={key} {...block} />
          case 'courseDocuments':
            return <DocumentsBlockComponent key={key} {...block} />
          case 'pageSection':
            return <SectionBlockComponent key={key} {...block} />
          case 'pageCallToAction':
            return <CallToActionBlockComponent key={key} {...block} />
          case 'pageImageText':
            return <ImageTextBlockComponent key={key} {...block} />
          default:
            return null
        }
      })}
    </div>
  )
}
